{
    "account": "Konto",
    "system_info": "System-Info",
    "dashboard": "Dashboard",
    "opos_list": "OPOS Liste",
    "subscriptions": "Abonnements",
    "credit_card": "Karten",
    "employees": "Mitarbeiter:innen",
    "cost_centers": "Kostenstellen",
    "vendors": "Lieferanten",
    "reporting": "Reporting",
    "ai_reporting": "Globale Insights",
    "settings": "Einstellungen",
    "logout": "Abmelden",
    "login": "Anmelden",
    "register": "Registrieren",
    "forgot_password": "Passwort vergessen?",
    "imprint": "Impressum",
    "privacy": "Datenschutz",
    "terms_of_use": "Nutzungsbedingungen",
    "go_back": "Zurück",
    "go_back_to_homepage": "Zurück zur Homepage",
    "back_to_requests": "Zurück zu Anträgen",
    "back_to_login": "Zurück zum Login",
    "back_to_subscriptions": "Zurück zu Abonnements",
    "bug_report": "Feedback",
    "help_center": "Hilfe",
    "transactions": "Transaktionen",
    "workflows": "Workflows",
    "liquidity": "Liquidität",
    "cashflow_planning": "Cashflow Planung",
    "category_settings": "Kategorisierung",
    "user_management": "Benutzerverwaltung",
    "purchase_orders": "Bestellungen",
    "delivery_notes": "Lieferscheine"
}
